import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-payments-teacher',
    templateUrl: './payments-teacher.component.html',
    styleUrls: ['./payments-teacher.component.scss']
})
export class PaymentsTeacherComponent implements OnInit {
    static modalRef;

    constructor() {
    }

    ngOnInit() {
    }

    close() {
        PaymentsTeacherComponent.modalRef.close();
    }
}
